import classnames from "classnames";
import React, { type ReactNode } from "react";

export const DetailsItemGrid = ({
  className,
  children,
}: {
  className?: string;
  children?: ReactNode;
}) => {
  return (
    <dl
      className={classnames(
        "m-0 lg:grid lg:grid-cols-[auto_1fr] lg:gap-x-4 lg:gap-y-3",
        className,
      )}
    >
      {children}
    </dl>
  );
};
